import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import NotFound from "./NotFound";
import Page from "./Page";
import Header from "./Header";
import Footer from "./Footer";

function ErrorHandler({ t, i18n, internalServerError, children }) {
  // Callback for changing languages.
  const changeLanguage = (e, langCode) => {
    e.preventDefault();
    i18n.changeLanguage(langCode);
  };

  if (internalServerError) {
    return (
      <Page>
        <Header
          title="eVS"
          telusSiteText={t("headerTelusSiteText")}
          currentLanguage={i18n.language}
          changeLanguageCallback={changeLanguage}
        />
        <NotFound content={t("internalServerError")} />
        <Footer />
      </Page>
    );
  }

  return children;
}

ErrorHandler.propTypes = {
  t: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    language: PropTypes.string,
    changeLanguage: PropTypes.func.isRequired,
  }).isRequired,
  internalServerError: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
};

export default withTranslation()(ErrorHandler);
